import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider, useSite } from "@/context/SiteContext";
import { PrelaunchGate } from "@/components/site/PrelaunchGate";
import Landing from "@/pages/Landing";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { ProtectedRoute } from "@/components/site/ProtectedRoute";
import Home from "@/pages/Home";
import Directory from "@/pages/Directory";
import QIProfile from "@/pages/QIProfile";
import Login from "@/pages/Login";
import Intake from "@/pages/Intake";
import Dashboard from "@/pages/Dashboard";
import Chat from "@/pages/Chat";
import Admin from "@/pages/Admin";
import Waitlist from "@/pages/Waitlist";
import PartnerIntake from "@/pages/PartnerIntake";
import Partners from "@/pages/Partners";
import StatePage from "@/pages/StatePage";
import CityPage from "@/pages/CityPage";
import StatesIndex from "@/pages/StatesIndex";

function ScrollToTop() {
  const { pathname, search, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      document.getElementById(hash.slice(1))?.scrollIntoView();
      return;
    }
    window.scrollTo(0, 0);
  }, [pathname, search, hash]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  const { launched } = useSite();
  const gate = (el) => <PrelaunchGate>{el}</PrelaunchGate>;
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={launched === null ? null : launched ? <Home /> : <Landing />} />
          <Route path="/directory" element={gate(<Directory />)} />
          <Route path="/qi/:slug" element={gate(<QIProfile />)} />
          <Route path="/login" element={<Login />} />
          <Route path="/waitlist" element={<Waitlist />} />
          <Route path="/1031-exchange" element={gate(<StatesIndex />)} />
          <Route path="/1031-exchange/:stateSlug" element={gate(<StatePage />)} />
          <Route path="/1031-exchange/:stateSlug/:citySlug" element={gate(<CityPage />)} />
          <Route path="/intake" element={<ProtectedRoute><Intake /></ProtectedRoute>} />
          <Route path="/partner-intake" element={<ProtectedRoute><PartnerIntake /></ProtectedRoute>} />
          <Route path="/partners" element={<ProtectedRoute><Partners /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/chat" element={<ProtectedRoute><Chat /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute admin><Admin /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SiteProvider>
            <AppRouter />
            <Toaster theme="dark" position="top-right" />
          </SiteProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
